import {ApolloLink, HttpLink, ApolloClient} from '@apollo/client'
import {InMemoryCache} from '@apollo/client/cache'
import {isClient} from '../../utils'
import getSessionLink from './links/session'
import getCookieLink from './links/cookie'
import getLogLink from './links/log'
import getLoginRedirectLink from './links/loginRedirect'
import fetch from '../fetch'

function getNewClient(options) {
  return new ApolloClient({
    ...options,
    ssrMode: !isClient()
  })
}

function getNewCache({state}) {
  const cache = new InMemoryCache()

  if (state) {
    cache.restore(state)
  }

  return cache
}

function getApolloClient(cookies, options) {
  const {headers} = options,
    cache = getNewCache(options),
    link = ApolloLink.from([
      getSessionLink(cookies, options),
      getCookieLink(options),
      getLogLink(cookies),
      getLoginRedirectLink(cookies, options),
      new HttpLink({uri: options.uri, credentials: 'same-origin', headers, fetch})
    ])

  return getNewClient({
    link,
    cache
  })
}

export {
  getNewClient,
  getNewCache,
  getApolloClient
}
